import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Menu } from "lucide-react"; // Icon for open/close sidebar
import adminLogo from "./AdminImage/logo-light-icon.png";
import config from "../../function/config";
import axios from "axios";
import admin from "./AdminImage/user3jpeg.jpeg";
import { motion } from "framer-motion";
import { toast } from "react-toastify";

export default function UpdaetViewShip() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [openDropdown, setOpenDropdown] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200); // Check screen size

  const [loading, setLoading] = useState("");

  const toggleDropdown = (id) => {
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if clicking the same dropdown
    } else {
      setOpenDropdown(id); // Open the clicked dropdown
    }
  };

  const [allCategory, setallCategory] = useState([]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1200);
      if (window.innerWidth <= 1200) {
        setIsSidebarOpen(false); // Hide sidebar by default on small screens
        setOpenDropdown(false);
      }
    };

    handleResize(); // Call on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Toggle dropdown
  const toggleDropdownprofile = (e) => {
    e.stopPropagation(); // Prevent click event from bubbling
    setIsOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [hasNotification, setHasNotification] = useState(true);
  const [isOpennoti, setIsOpennoti] = useState(false);
  const toggleDropdownNotification = (e) => {
    e.stopPropagation();
    setIsOpennoti((prev) => !prev);

    // Remove notification dot when opening dropdown
    if (hasNotification) {
      setHasNotification(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpennoti(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const [allSubCategory, setallSubCategory] = useState([]);

  const { id } = useParams();

  const [CategoryTitle, setCategoryTitle] = useState("");
  const [Category, setCategory] = useState("");
  const [SubCategoryDescription, setSubCategoryDescription] = useState("");
  const [Title, setTitle] = useState("");
  const [vesselType, setvesselType] = useState("");
  const [ShortDescription, setShortDescription] = useState("");
  const [Flag, setFlag] = useState("");
  const [YearBuilt, setYearBuilt] = useState("");
  const [Capacity, setCapacity] = useState("");
  const [LOA, setLOA] = useState("");
  const [Class, setClass] = useState("");
  const [GRTNRT, setGRTNRT] = useState("");
  const [Teu, setTeu] = useState("");
  const [Hidden, setHidden] = useState("");
  const [MainEngine, setMainEngine] = useState("");
  const [DWT, setDWT] = useState("");

  const [Email, setEmail] = useState("");
  const [MobileNO, setMobileNO] = useState("");
  const [BriefDescription, setBriefDescription] = useState("");
  const [Image, setImage] = useState("");
  const [ci, setCi] = useState("");
  const [cImage, setCImage] = useState("");
  const [am, setAm] = useState("");
  const [Price, setPrice] = useState("");

  const navigate = useNavigate();

  // fetch Category  data
  // Function to merge ship amenities with available amenities
  const mergeAmenities = (shipAmenities, allAmenities) => {
    const merged = allAmenities.reduce((acc, amenity) => {
      const found = shipAmenities.find(
        (item) => item.name === amenity.amenities
      );
      acc[amenity.amenities] = found ? found.value : ""; // If found, set value, else empty
      return acc;
    }, {});
    setFormDataA((prev) => ({ ...prev, ...merged }));
  };

  // Fetch ship data and categories
  useEffect(() => {
    async function fetchShipData() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/single/${id}`
        );
        if (res1.data.status === 200) {
          const shipAmenities = res1.data.data.amenities;
          setTitle(res1.data.data.title);
          setvesselType(res1.data.data.vessel_type);
          setSelectedCategory(res1.data.data.main_category);
          setFlag(res1.data.data.flag);
          setCapacity(res1.data.data.capacity);
          setLOA(res1.data.data.LOA);
          setYearBuilt(res1.data.data.year_built);
          setClass(res1.data.data.Class);
          setGRTNRT(res1.data.data.GRT_NRT);
          setTeu(res1.data.data.Teu);
          setMainEngine(res1.data.data.main_engine);
          setDWT(res1.data.data.DWT);
          setHidden(res1.data.data.hidden_details);
          setShortDescription(res1.data.data.short_description);
          setBriefDescription(res1.data.data.brief_description);
          setEmail(res1.data.data.email);
          setMobileNO(res1.data.data.phone);
          setPrice(res1.data.data.Price);
          setSubType(res1.data.data.sub_type)

          setAm(shipAmenities);

          const res2 = await axios.get(
            `${config.base_url}/api/HappyMarineShipping/viewAmenities`
          );
          if (res2.data.status === 200) {
            setAmenities(res2.data.data);
            mergeAmenities(shipAmenities, res2.data.data); // Merge ship data with input fields
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchShipData();
  }, [config.base_url, id]);

  const [amenities, setAmenities] = useState([]);
  const [formDataA, setFormDataA] = useState({});

  // Fetch amenities from the backend
  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewAmenities`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setAmenities(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);

  // Handle input change
  const handleChange = (e, name) => {
    const { value } = e.target;
    setFormDataA((prev) => ({ ...prev, [name]: value }));
  };

  const [Amenity, setAmenity] = useState([]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleAmenity/${id}`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res.data.status === 200) {
          console.log(res);
          setAmenity(res.data.data.value);
        } else {
          console.log(res);
        }
      } catch (err) {
        console.log("error2", err);
      }
    }
    fetchdata();
  }, [config.base_url]);

  const [selectedCategory, setSelectedCategory] = useState(""); // Track selected main category
  const [filteredSubCategories, setFilteredSubCategories] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallSubCategory(res1.data.data);
        }

        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewCategory`,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (res2.data.status === 200) {
          console.log(res2);
          setallCategory(res2.data.data);
        }
      } catch (error) {
        console.error("Error fetching data", error);
      }
    }
    fetchData();
  }, [config.base_url, count]);

  const [allShips, setallShips] = useState([]);

  // fetch ship data
  useEffect(() => {
    async function fetchdata() {
      try {
        const res1 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewShipForSale`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (res1.data.status === 200) {
          console.log(res1);
          setallShips(res1.data.data);
        } else {
          console.log("error");
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [config.base_url, count]);
  const [newShip, setNewShip] = useState(
    JSON.parse(localStorage.getItem("newShip")) || false
  );
  const [prevShipCount, setPrevShipCount] = useState(
    JSON.parse(localStorage.getItem("prevShipCount")) || 0
  );

  const handleView = () => {
    setNewShip(false);
    localStorage.setItem("newShip", JSON.stringify(false));
    setPrevShipCount(allShips.length);
    localStorage.setItem("prevShipCount", JSON.stringify(allShips.length));
  };

  const [allImages, setAllImages] = useState([]);
  const [newImages, setNewImages] = useState([]);

  const [mainImages, setMainImages] = useState([]); // Array to store multiple images

  useEffect(() => {
    async function fetchShipImages() {
      try {
        const response = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/singleShipImage/${id}`
        );
        if (response.data.status === 200 && response.data.data.length > 0) {
          const mainImagesData = response.data.data.filter(
            (img) => img.image !== null
          );
          setMainImages(mainImagesData);
        }
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    }

    fetchShipImages();
  }, [id]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setNewImages((prev) => [...prev, ...files]);
    e.target.value = null; // clear the input so you can re-upload the same file if needed
  };

  // Filter subcategories when main category changes
  useEffect(() => {
    if (selectedCategory) {
      const filtered = allSubCategory.filter(
        (sub) => Number(sub.category) === Number(selectedCategory) // Convert both to numbers
      );
      setFilteredSubCategories(filtered);
    } else {
      setFilteredSubCategories([]);
    }
  }, [selectedCategory, allSubCategory]);

  const [generatedCode, setGeneratedCode] = useState("");
  const [codeCounter, setCodeCounter] = useState("");

  const normalize = (str) => str.toLowerCase().replace(/[^a-z]/g, "");

  const subCategoryPrefixes = {
    barge: "BRG",
    bulk: "BLK",
    cargo: "CRG",
    container: "CNT",
    fishing: "FIS",
    multipurpose: "MPP",
    passengerferry: "PAX",
    reefer: "REF",
    roro: "ROR",
    tanker: "TNK",
    tugboat: "TUG",
    dredger: "DRG",
    floatingcrane: "FLC",
    landingcraft: "LCT",
    yacht: "YCT",
    supplyboat: "SUB",
    crewboat: "CRB",
    floatingdock: "FLD",
    others: "OTR",
  };

  useEffect(() => {
    if (vesselType) {
      const normalized = normalize(vesselType);
      const prefix = subCategoryPrefixes[normalized];
      if (prefix) {
        setGeneratedCode(prefix); // ✅ Only set the prefix
      } else {
        setGeneratedCode("");
      }
    }
  }, [vesselType]);


  const[SubType,setSubType] = useState('')
  
    const vesselSubTypes = {
    Barge: [" Cargo Barge","Tanker Barge", "Accommodation Barge", "Self-Propelled Barge"],
    Bulk: ["Handymax Bulk Carrier","Supramax Bulk Carrier","Ultramax Bulk Carrier","Panamax Bulk Carrier","Kamsarmax Bulk Carrier", "Mini Bulk Carrier","Post-Panamax Bulk Carrier", "Log Carrier", "Cement Carrier"],
    Cargo: ["General Cargo"],
    Container: ["Feeder Container Ship","Panamax Container Ship","Post-Panamax Container Ship","New Panamax (Neo-Panamax)","Mega Container carrier","Fully Cellular Container Ship","Container Barge"],
    Fishing: ["Longliner", "Purse Seiner","Shrimp Trawler","Stern Trawler"],
    Multipurpose: ["General Cargo + Container Ship","General Cargo + Bulk Carrier","Container + Ro-Ro Ship (ConRo)","Heavy Lift Multipurpose Vessel","Tweendecker (with multiple cargo decks)",'Livestock'],
    "Passenger/Ferry":["Cruise Ship","High-Speed Craft", "Catamaran Ferry", "Hydrofoil", "Hovercraft", "Day Passenger Vessel", "Water Taxi"],
    Reefer: ["Conventional Reefer Ship","Reefer Container Ship","Side Door Reefer Ship","Palletized Reefer Ship","Fish Reefer Vessel"],
    RoRo:["Pure Car Carrier (PCC)", "Ro-Ro Cargo Ship","Ro-Pax Ship (Ro-Ro + Passenger)","LOLO Cargo Ship","Double-Ended Ro-Ro"],
    Tanker: ["Crude Oil Tanker","Product Tanker","Chemical Tanker","LNG Carrier (Liquefied Natural Gas)","LPG Carrier (Liquefied Petroleum Gas)","Bitumen Tanker","Oil Recovery Vessel","Bunker vessel ","Slop Barge Tanker","Water Tanker", "Edible Oil Tanker"],
    Dredger: ["Cutter Suction Dredger","Hopper Dredger","Bucket Dredger","Backhoe Dredger","Grab Dredger"],
    "Floating Crane": ["Sheerleg Crane Vessel","Crane Barge","Jack-Up Crane Vessel","Derrick Barge","Floating Gantry Crane"],
    "Floating Dock": ["Pontoon-Type Floating Dock","Submersible Floating Dock","Ship-Lift Floating Dock","Floating Dry Dock"],
    "Landing Craft": ["Landing Craft Utility (LCU)","Landing Craft tanker"],
    Yacht:["Sailing Yacht","Motor Yacht","Catamaran Yacht","Trimaran Yacht","Superyacht","Megayacht","Flybridge Yacht"],
    "Tug Boat":["Harbor Tug","Ocean Tug","Escort Tug","Azimuth Stern Drive (ASD) Tug","Pusher Tug","Anchor Handling Tug (AHT)"],
    "Supply Boat":["Platform Supply Vessel (PSV)","Anchor Handling Tug Supply (AHTS)","Utility Vessel","Multi-Purpose Support Vessel (MPSV)","Diving Support Vessel (DSV)","Cable Laying Vessel","Accommodation Supply Vessel","DP Supply Boat (Dynamic Positioning)"],
    "Crew Boat": [" Fast Crew Boat","Fast Supply Intervention Vessel (FSIV)"],
    Other: [""]
  };
    

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Create a new FormData object to handle file uploads properly
    const formData = new FormData();
    formData.append("vessel_type", vesselType);
    formData.append("short_description", ShortDescription);
    formData.append("flag", Flag);
    if (YearBuilt === "null" || YearBuilt === null) {
      formData.append("year_built", ""); // Or do not append this key if it's optional
    } else {
      formData.append("year_built", YearBuilt);
    }
    formData.append("capacity", Capacity);
    if (LOA) {
      formData.append("LOA", LOA);
    } else {
      formData.append("LOA", ""); // Or skip appending if it's optional
    }

    if (Email === "null" || Email === null) {
      formData.append("email", "");
    } else {
      formData.append("email", Email);
    }
    // Append amenities as key-value pairs
    Object.entries(formDataA).forEach(([key, value]) => {
      formData.append(`value[${key}]`, value);
    });

    formData.append("phone", MobileNO);
    formData.append("sub_type", SubType);
    formData.append("brief_description", BriefDescription);
    formData.append("main_category", selectedCategory);
    formData.append("ship_code", generatedCode);
    formData.append("Price", Price);

    // Append amenities as key-value pairs
    Object.entries(formDataA).forEach(([key, value]) => {
      formData.append(`value[${key}]`, value);
    });

    // Append the updated list of images (mainImages)
    newImages.forEach((file) => {
      formData.append("image", file);
    });

    try {
      const response = await axios.put(
        `${config.base_url}/api/HappyMarineShipping/updateShip/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Backend Response:", response.data);
      console.log(...formData);

      if (response.data.status === 200) {
        setLoading(false);
        setCount(id);
        toast.success("Ship Updated Successfully!", {
          autoClose: 1500,
          position: "top-right",
        });
        navigate("/admin/viewShip");
      } else {
        setLoading(false);
        toast.error("Fill the required Fields", {
          autoClose: 1500,
          position: "top-right",
        });
      }
    } catch (err) {
      setLoading(false);
      toast.error("Error", {
        autoClose: 2000,
        position: "top-right",
      });
      console.log("Error during the submit:", err);
    }
  };

  const handleDeleteImage = async (item, isNew, e) => {
    // Prevent default form submission behavior
    if (e) e.preventDefault();
    
    if (isNew) {
      // Remove only from newImages state
      setNewImages((prev) => prev.filter((file) => file !== item));
    } else {
      try {
        await axios.delete(
          `${config.base_url}/api/HappyMarineShipping/deleteShipImage/${item.id}`
        );
        setMainImages((prev) => prev.filter((img) => img.id !== item.id));
        toast.success("Image deleted successfully", {
          autoClose: 1500,
          position: "top-right",
        });
      } catch (error) {
        console.error("Error deleting image:", error);
        toast.error("Error deleting image from database", {
          autoClose: 2000,
          position: "top-right",
        });
      }
    }
  };

  const cleanInput = (input) => {
    return input.replace(/[\u200B-\u200D\uFEFF]/g, ""); // Remove Zero-width characters and BOM
  };

  return (
    <div className="h-screen flex flex-col bg-gray-100">
      {/* Navbar - Full Width, Above Sidebar */}
      <nav className="bg-[#123d5f] p-4 flex items-center shadow-md w-full transition-all duration-300">
        {/* Left Side - Admin Logo & Title */}
        <div className="flex items-center gap-2">
          <img src={adminLogo} className="w-[35px] h-[35px]" alt="Admin Logo" />
          {isSidebarOpen && (
            <h1 className="text-lg font-bold text-white">Admin</h1>
          )}
        </div>

        {/* Menu Button (Moves on Sidebar Toggle) */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-60" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>
        {/* mobile screen menu button */}
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`absolute xm:block hidden transition-all duration-300 text-white ${
            isSidebarOpen ? "left-32" : "left-16"
          }`}
        >
          <Menu size={28} />
        </button>

        {/* Admin Profile  (Right Side) */}
        <div className="relative ml-auto pr-5 flex items-center gap-20">
          {/* notification */}

          {/* Admin Image */}
          <div>
            <img
              src={admin} // Replace with {admin} if using a variable
              className="rounded-full w-[35px] cursor-pointer"
              alt="admin"
              onClick={toggleDropdownprofile}
            />
            {/* Dropdown */}
            {isOpen && (
              <motion.div
                ref={dropdownRef}
                initial={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                animate={{ opacity: 1, rotateX: 0, scale: 1 }}
                exit={{ opacity: 0, rotateX: 90, scale: 0.9 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-40 py-2 origin-top transform"
              >
                <ul className="text-gray-700">
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={"/admin/profile"}>Profile</Link>
                  </li>
                  <li className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                    <Link to={"/login"} className="text-red-500">
                      <i class="bx bx-log-out"></i> Logout
                    </Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </div>
        </div>
      </nav>

      {/* Sidebar & Content Wrapper */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className={`${
            isSidebarOpen ? "w-60 overflow-y-auto" : "w-16"
          }  bg-white xl:hidden text-[#8D97AD] shadow-xl transition-all duration-300  max-h-screen `}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className="px-4 py-2 text-lg   flex items-center">
              <i className="fa-solid fa-gauge mr-3"></i>
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>

            {isSidebarOpen && (
              <div className="px-5 mt-2 w-[75%]">
                <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                  Registrations
                </h1>
              </div>
            )}

            {/* Ship For Sale Dropdown */}
            <li className="px-2   text-lg  flex flex-col  relative">
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg  flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Open Cargo </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-2  text-lg  flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  <h1 className="text-xl text-center font-semibold">-</h1>
                  {isSidebarOpen && <span>Supply Equipments </span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 text-[#8D97AD] py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {isSidebarOpen && (
              <div className="px-5 mt-2 w-[75%]">
                <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                  Approvals
                </h1>
              </div>
            )}
            {isSidebarOpen && (
              <ul className="px-2  text-lg flex flex-col relative group">
                <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                  <Link
                    to="/admin/shipforsale"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Ships For Sale
                  </Link>
                  {newShip && (
                    <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                      New
                    </span>
                  )}
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                    to="/admin/shipforCharterApp"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Ship For Charter
                  </Link>
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                  to='/admin/LogisticsAppr'
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Open Cargo
                  </Link>
                </li>

                <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                  <Link
                    to="/admin/shipforEqApp"
                    onClick={() => handleView()} // Ensure it runs before navigation
                  >
                    - Supply Equipments
                  </Link>
                </li>
              </ul>
            )}

            {/* Settings Dropdown */}
            <li className="px-3 py-2 text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  <i className="fa-solid fa-gear"></i>
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to={"/login"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/login"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>

        {/* mobile screen sidebar */}

        <div
          className={`fixed hidden xl:block h-full bg-white text-[#8D97AD] shadow-xl transition-all duration-300 ${
            isMobile
              ? isSidebarOpen
                ? "w-full translate-x-0" // Open in full width on mobile
                : "-translate-x-full w-0" // Hide sidebar on mobile
              : isSidebarOpen
              ? "w-60 translate-x-0" // Open normally on desktop
              : "w-0" // Hide sidebar on desktop
          }`}
        >
          <ul className="mt-10 flex flex-col gap-3 ">
            {/* Dashboard */}
            <li className={`px-4 py-2 text-lg    flex items-center`}>
              {isSidebarOpen && <i className="fa-solid fa-gauge mr-3"></i>}
              {isSidebarOpen && <Link to="/login/dashboard">Dashboard</Link>}
            </li>
            {isSidebarOpen && (
              <div className="px-5  w-[50%]">
                <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                  Registrations
                </h1>
              </div>
            )}
            {/* Ship For Sale Dropdown */}
            <li className={`px-2  text-lg  flex flex-col  relative`}>
              <div
                className="flex items-center  justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(1)} // Toggle Ship For Sale dropdown
              >
                <div className="flex items-center  gap-2 hover:text-[#00c292]">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Ship For Sale</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 1 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 1 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 1
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addShip">Add Ships</Link>
                    </li>
                    <li className="px-4 text-[#8D97AD] py-1 hover:text-[#00c292]">
                      <Link to="/admin/viewShip">View Ships</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg  flex flex-col relative">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(2)} // Toggle Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Ship For Charter</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 2 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>
              {!isSidebarOpen && openDropdown === 2 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-1 py-1 w-full text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 2
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/addCharter">Add Charter</Link>
                    </li>
                    <li className="px-4 py-1 text-[#8D97AD] hover:text-[#00c292]">
                      <Link to="/admin/shipforCharter">View Charter</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3  text-lg flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(3)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Open Cargo</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 3 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 3 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 3
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to='/admin/addcargo'>Add Cargo</Link>
                    </li>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                       <Link to='/admin/viewCargo' >View Cargo</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg  flex flex-col relative group ">
              <div
                className="flex items-center justify-between cursor-pointer p-2"
                onClick={() => toggleDropdown(4)} // Toggle Sub Category dropdown
              >
                <div className="flex items-center hover:text-[#00c292] gap-2">
                  {isSidebarOpen && (
                    <h1 className="text-xl text-center font-semibold">-</h1>
                  )}
                  {isSidebarOpen && <span>Supply Equipments</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 4 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {!isSidebarOpen && openDropdown === 4 && (
                <div className="absolute left-full top-0 bg-white shadow-lg rounded-md py-2 w-56 z-20">
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Dropdown Content */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 4
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-1 w-full hover:text-[#00c292]">
                      <Link to="/admin/addsEq">Add Equipments</Link>
                    </li>
                    <li className="px-1 py-1 text-[#8D97AD] w-full hover:text-[#00c292]">
                      <Link to="/admin/shipforEq">View Equipments</Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            <li className="px-3 text-lg flex flex-col relative group">
              {/* Clickable Div */}
              {isSidebarOpen && (
                <div className="px-5  w-[50%]">
                  <h1 className="text-xl font-semibold border-b border-[#8D97AD] text-[#8D97AD]">
                    Approvals
                  </h1>
                </div>
              )}

              {isSidebarOpen && (
                <ul
                  className="px-2 py-2  text-lg flex gap-3
                                                                                                                    flex-col relative group"
                >
                  <li className="px-1 py-2 hover:text-[#00c292] flex justify-between items-center">
                    <Link
                      to="/admin/shipforsale"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Ships For Sale
                    </Link>
                    {newShip && (
                      <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                        New
                      </span>
                    )}
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                      to="/admin/shipforCharterApp"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Ship For Charter
                    </Link>
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                    to='/admin/LogisticsAppr'
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Open Cargo
                    </Link>
                  </li>

                  <li className="px-1 py-2 hover:text-[#00c292]  flex justify-between items-center">
                    <Link
                      to="/admin/shipforEqApp"
                      onClick={() => handleView()} // Ensure it runs before navigation
                    >
                      - Supply Equipments
                    </Link>
                  </li>
                </ul>
              )}

              {/* Click Dropdown (For open sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 5
                      ? "max-h-48 opacity-100 "
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforsale"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Ships For Sale
                      </Link>
                      {newShip && (
                        <span className="ml-2 text-xs bg-red-500 text-white px-2 py-1 rounded-full">
                          New
                        </span>
                      )}
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforCharterApp"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Ship For Charter
                      </Link>
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                      to='/admin/LogisticsAppr'
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Open Cargo
                      </Link>
                    </li>

                    <li className="px-1 py-2 hover:bg-gray-100 flex justify-between items-center">
                      <Link
                        to="/admin/shipforEqApp"
                        onClick={() => handleView()} // Ensure it runs before navigation
                      >
                        - Supply Equipments
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Settings Dropdown */}
            <li className="px-3  text-lg flex flex-col relative group">
              <div
                className="flex items-center justify-between cursor-pointer p-2 hover:text-[#00c292]"
                onClick={() => toggleDropdown(6)}
              >
                <div className="flex items-center gap-2">
                  {isSidebarOpen && <i className="fa-solid fa-gear"></i>}
                  {isSidebarOpen && <span>Settings</span>}
                </div>
                {isSidebarOpen && (
                  <i
                    className={`fa-solid ${
                      openDropdown === 6 ? "fa-chevron-up" : "fa-chevron-right"
                    }`}
                  ></i>
                )}
              </div>

              {/* Hover Dropdown (Closed Sidebar) */}
              {!isSidebarOpen && openDropdown === 6 && (
                <div className="absolute left-full top-0 bg-white shadow-lg transition-all duration-300 w-40 py-2 rounded-lg z-20">
                  <ul>
                    <li className="px-4 py-2 hover:bg-gray-100">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/login"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}

              {/* Click Dropdown (Open Sidebar) */}
              {isSidebarOpen && (
                <div
                  className={`ml-6 mt-2 transition-all duration-300 ${
                    openDropdown === 6
                      ? "max-h-40 opacity-100"
                      : "max-h-0 opacity-0 overflow-hidden"
                  }`}
                >
                  <ul>
                    <li className="px-4 py-1 hover:text-[#00c292]">
                      <Link to="/admin/profile">Profile</Link>
                    </li>
                    <li className="px-3 py-1 hover:text-[#00c292]">
                      <Link to={"/login"} className="text-red-500">
                        <i class="bx bx-log-out"></i> Logout
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          </ul>
        </div>
 
        {/* Main Content */}
        <div className="flex-1 py-4 overflow-y-auto">
          <div className="bg-white  shadow-sm text-xl w-full p-5">
            <div className="flex justify-between items-center">
              <h1>Edit Ship </h1>
              <div className="flex text-sm gap-2">
                <Link to={"/adminHome"}>Home</Link> <span>/</span>
                <p className="text-[#00c292]">Edit Ship Category</p>
              </div>
            </div>
          </div>
          <div className="w-full py-5 px-4">
            <form className="bg-white  px-5 mt-5 rounded ">
              {/* main category and sub category */}
              <div className="p-5 flex xm:flex-wrap gap-5 items-center">
                <div className=" w-[100%]">
                  <label htmlFor="VesselType" className="font-semibold">
                    Vessel Type
                  </label>
                  <select
                    value={vesselType}
                    onChange={(e) => setvesselType(e.target.value)}
                    className="w-full mt-4 rounded border border-gray-400 p-2 text-[#d1a460]"
                    name="vesselType"
                    id="VesselType"
                  >
                    <option hidden selected value="">
                      -Select-
                    </option>
                    <option
                      disabled
                      className="text-gray-500 font-semibold"
                      value=""
                    >
                      Catagories
                    </option>
                    <option value="Barge" className="text-gray-500">
                      Barge
                    </option>
                    <option value="Bulk" className="text-gray-500">
                      Bulk
                    </option>
                    <option value="Cargo" className="text-gray-500">
                      Cargo
                    </option>
                    <option value="Container" className="text-gray-500">
                      Container
                    </option>
                    <option value="Fishing" className="text-gray-500">
                      Fishing
                    </option>
                    <option value="Multipurpose" className="text-gray-500">
                      Multipurpose
                    </option>
                    <option value="Passenger/Ferry" className="text-gray-500">
                      Passenger/Ferry
                    </option>
                    <option value="Reefer" className="text-gray-500">
                      Reefer
                    </option>
                    <option value="RoRo" className="text-gray-500">
                      RoRo
                    </option>
                    <option value="Tanker" className="text-gray-500">
                      Tanker
                    </option>
                    <option value="Dredger" className="text-gray-500">
                      Dredger
                    </option>
                    <option value="Floating Crane" className="text-gray-500">
                      Floating Crane
                    </option>
                    <option value="Floating Dock" className="text-gray-500">
                      Floating Dock
                    </option>
                    <option value="Landing Craft" className="text-gray-500">
                      Landing Craft
                    </option>
                    <option value="Yacht" className="text-gray-500">
                      Yacht
                    </option>
                    <option value="Tug Boat" className="text-gray-500">
                      Tug Boat
                    </option>
                    <option value="Supply Boat" className="text-gray-500">
                      Supply Boat
                    </option><option value="crew Boat" className="text-gray-500">
                      Crew Boat
                    </option>
                    <option value="Other" className="text-gray-500">
                      Other
                    </option>
                  </select>
                </div>

                 {vesselType && vesselSubTypes[vesselType] && (
  <div className="w-[100%]">
    <label htmlFor="SubType" className="font-semibold">
      Vessel Sub-Type
    </label>
    <select
      value={SubType}
      onChange={(e) => setSubType(e.target.value)}
      className="w-full mt-4 rounded border border-gray-400 p-2 text-[#d1a460]"
      name="SubType"
      id="SubType"
    >
      <option hidden value="">
        - Select Sub-Type -
      </option>
      {vesselSubTypes[vesselType].map((sub, idx) => (
        <option key={idx} value={sub.trim()}>
          {sub.trim()}
        </option>
      ))}
    </select>
  </div>
)}

                {generatedCode && (
  <div className="w-[50%] xm:w-[100%]">
    <label htmlFor="GeneratedCode">Refernce Id</label>
    <input
      value={generatedCode}
      onChange={(e)=> setGeneratedCode(e.target.value)}
      className="w-full mt-2 rounded border border-gray-400 p-2 text-gray-500"
      id="GeneratedCode"
      disabled
    />
  </div>
)}
              </div>

              {/* short description */}
              <div className="p-5">
                <label htmlFor="shortDescription" className="">
                  Short Description
                </label>
                <textarea
                  placeholder="Enter Ship Name/Country/Yr Built..."
                  value={ShortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="shortDescription"
                ></textarea>
              </div>

              {/* flag and Year Built*/}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Flag" className="">
                    Flag
                  </label>
                  <input
                    placeholder="Enter the Country Name"
                    value={Flag}
                    onChange={(e) => setFlag(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Flag"
                  />
                </div>

                {/* <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Capacity" className="">
                    Capacity
                  </label>
                  <input
                    value={Capacity}
                    onChange={(e) => setCapacity(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    placeholder="Enter the Capacity"
                    name=""
                    id="Capacity"
                  />
                </div> */}
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Length of all" className="">
                    Length of all:LOA(m)
                  </label>
                  <input
                    value={LOA}
                    onChange={(e) => setLOA(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Length of all"
                    placeholder="Enter LOA"
                  />
                </div>
              </div>

              {/* Year Built */}
              <div className="p-5 ">
                <div className="w-[50%] xm:w-[100%]">
                  <label htmlFor="Year Built" className="">
                    Built(Year)
                  </label>
                  <input
                    placeholder="Enter the Year"
                    value={YearBuilt}
                    onChange={(e) => setYearBuilt(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Year Built"
                  />
                </div>
              </div>

              <div className="w-full  p-5 ">
                <div>
                  <h1 className="text-xl border-gray-300 border-b">
                    Amenities
                  </h1>
                </div>
              </div>
              <div className="p-5 gap-5 grid grid-cols-3 xm:grid-cols-2 xs:grid-cols-1 items-center">
                {amenities.map((amenity, index) => (
                  <div key={index} className="flex flex-col gap-1 xm:w-[100%]">
                    <label htmlFor={amenity.amenities}>
                      {amenity.amenities}
                    </label>
                    <input
                      value={formDataA[amenity.amenities] || ""}
                      onChange={(e) => handleChange(e, amenity.amenities)}
                      className="w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
                      placeholder={`Enter ${amenity.amenities}`}
                      name={amenity.amenities}
                      id={amenity.amenities}
                    />
                  </div>
                ))}
              </div>

              {/* Price and scrap */}
              <div className="p-5 ">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Price" className="font-semibold">
                    Price(USD)
                  </label>
                  <input
                    value={Price}
                    onChange={(e) => setPrice(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Price"
                    placeholder="Enter the Price"
                  />
                </div>
              </div>

              {/*Contact */}
              <div className="p-5 flex gap-5 items-center xm:flex-wrap xm:gap-5">
                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Email" className="font-semibold">
                    Email
                  </label>
                  <input
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Email"
                    placeholder="Enter your Email"
                  />
                </div>

                <div className="flex flex-col gap-1 w-[50%] xm:w-[100%]">
                  <label htmlFor="Mobile No" className="font-semibold">
                    Mobile No
                  </label>
                  <input
                    value={MobileNO}
                    onChange={(e) => setMobileNO(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                    name=""
                    id="Mobile No"
                    placeholder="Enter Your Mobile No"
                  />
                </div>
              </div>

              {/* Brief Description */}
              <div className="p-5">
                <label htmlFor="Brief Description" className="">
                  Ship Particular
                </label>
                <textarea
                  value={BriefDescription}
                  onChange={(e) => setBriefDescription(e.target.value)}
                  rows={5}
                  className="w-full mt-2 rounded border border-gray-400  text-gray-500 p-2"
                  name=""
                  id="Brief Description"
                  placeholder="Write about your ship...."
                ></textarea>
              </div>

              {/* Thumbnail Image */}

              {/* Display All Images */}
              <div className="p-5">
                <label>Uploaded Images</label>
                <div className="flex flex-wrap gap-4 mt-3">
                  {[
                    // Existing images from server
                    ...mainImages.map((img) => ({
                      key: `server-${img.id}`,
                      src: img.image,
                      isNew: false,
                      item: img, // full object so we have id
                    })),
                    // New images from local file input
                    ...newImages.map((file, idx) => ({
                      key: `new-${file.name}-${idx}`,
                      src: URL.createObjectURL(file),
                      isNew: true,
                      item: file, // file object for local images
                    })),
                  ].map(({ key, src, isNew, item }) => (
                    <div key={key} className="relative">
                      <img src={src} className="w-[200px] h-[150px]" alt="" />

                      <button
                      type="button"
                        onClick={() => handleDeleteImage(item, isNew)}
                        className="absolute top-0 right-0 p-1 text-red-500"
                      >
                        Delete
                      </button>
                    </div>
                  ))}
                </div>
              </div>
              {/* Upload New Images */}
              <div className="p-5">
                {" "}
                <label htmlFor="UploadImage">Upload Image</label>{" "}
                <input
                  type="file"
                  multiple
                  onChange={handleImageChange}
                  className="imageInput w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
                  id="UploadImage"
                />{" "}
              </div>

              <hr className="text-gray-500 w-full" />
              <div className="p-4">
                <button
                  onClick={(e) => handleSubmit(e)}
                  type="submit"
                  className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded"
                >
                  {loading ? (
                    <span className="block w-[16px] h-[16px] border-2 border-b-0 border-white mt-[4px] mb-[4px] rounded-full m-auto animate-spin"></span>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
